export default __webpack_public_path__ + "static/media/Icon_Arrow-up.17b01d00.svg";